<template>
  <div>
    <el-upload
      :style="'width:100px;float:left;height:50px;'"
      class="upload-demo"
      :show-file-list="false"
      :action="action"
      style="display: inline-block; margin-right: 10px"
      :accept="accept"
      :on-success="uploadSuccessCommon"
      :before-upload="beforeAvatarUploadCommon"
      :on-exceed="handleExceedCommon"
      :file-list="files"
      with-credentials
    >
      <el-button
        size="small"
        style="margin: 10px 3px"
        type="primary"
        :disabled="disabled"
        >上传图片</el-button
      >
    </el-upload>
    <template v-if="imagesList.length">
      <div
        v-for="(item, index) in imagesList"
        :key="index"
        style="
          float: left;
          width: 50px;
          height: 50px;
          margin: 0 10px;
          border: 1px solid #ddd;
        "
      >
        <div style="position: relative">
          <template v-if="value.indexOf('pdf') > -1">
            <img
              src="https://static3.yishouapp.com/obs/tools/def/2022/4/20/dc7feaed3c8006c0f0c2c2a46b2d41ed.png"
              style="width: 50px; height: 50px"
              @click="handleOpen(origin + '/' + item)"
            />
          </template>

          <img
            v-else
            style="width: 50px; height: 50px"
            :src="origin + '/' + item"
            @click="previewImage(item)"
          />
          <div
            :style="{
              width: '15px',
              height: '15px',
              position: 'absolute',
              top: '-5px',
              right: '-5px',
              display: disabled ? 'none' : 'block',
            }"
            @click="deleteImgCommon(item)"
          >
            <img
              style="width: 15px; height: 15px"
              :src="origin + '/201804/13/15235857625ad012e238658.png'"
            />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  name: "UploadCommonTemplate",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: [String, Array],
      default: () => {
        return "" || [];
      },
    },
    origin: {
      type: String,
      default: "",
    },
    limit: {
      type: Number,
      default: 1,
    },
    modelName: {
      type: String,
      default: "",
    },
    accept: {
      type: String,
      default: "image/*",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imagesList: [],
      files: [],
      action: `${apiBaseURL}/erp/Common/erpUploadFile`,
    };
  },
  watch: {
    value: {
      handler(val) {
        if (!Array.isArray(val)) {
          if (val !== "") {
            if (this.imagesList.indexOf(val) < 0) {
              this.imagesList.push(val);
            }
          } else {
            this.imagesList = [];
          }
        } else {
          this.imagesList = val;
        }
      },
      immediate: true,
    },
  },
  methods: {
    async uploadSuccessCommon(res) {
      if (res.code !== 200) {
        this.$message.error(res.msg);
      } else {
        const img = res.data.files[0];
        try {
          const result = await this._checkUploadSuccess(res);
          if (result) {
            const valueArr = this.value;
            if (Array.isArray(this.value)) {
              valueArr.push(img);
            }
            this.$emit("input", Array.isArray(this.value) ? valueArr : img);
            if (this.imagesList.indexOf(img) < 0) {
              this.imagesList.push(img);
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    beforeAvatarUploadCommon(file) {
      //   目前只有 1 跟 9的情况 简单处理
      if (
        Array.isArray(this.value) &&
        this.value.length >= 9 &&
        this.limit === 9
      ) {
        return this.validateMsgNum();
      }
      if (typeof this.value === "string" && !!this.value && this.limit === 1) {
        return this.validateMsgNum();
      }
      const size = (file.size / 1024 / 1024).toFixed(2);
      if (this.limit === 1 && size > 2) {
        return this.validateMsgSize(2, size);
      }
      if (this.limit === 9 && size > 10) {
        return this.validateMsgSize(10, size);
      }
    },
    handleExceedCommon() {
      if (
        Array.isArray(this.value) &&
        this.value.length >= 9 &&
        this.limit === 9
      ) {
        this.validateMsgNum();
      }
      if (typeof this.value === "string" && !!this.value && this.limit === 1) {
        this.validateMsgNum();
      }
    },
    deleteImgCommon(v) {
      if (this.imagesList.indexOf(v) >= 0) {
        this.imagesList.splice(this.imagesList.indexOf(v), 1);

        if (Array.isArray(this.value)) {
          const newArr = this.value;
          const valueInput = newArr.filter((item) => {
            return item !== v;
          });
          this.$emit("input", valueInput);
        } else {
          this.$emit("input", "");
        }
      }
    },
    previewImage(item) {
      this.$emit("preview-image", item);
    },
    async _checkUploadSuccess(res) {
      let result = true;
      try {
        if (this.modelName === "avatar") {
          result = await this._avatarSuccessCheck(res);
        }
      } catch (error) {
        console.log(error);
      }

      return result;
    },
    validateMsgSize(sizeTip, size) {
      this.$message.error(
        `图片太大了,请缩小到${sizeTip}MB以内再上传,当前图片大小:"${size}MB"`
      );
      return false;
    },
    validateMsgNum() {
      this.$message.warning(`只能上传${this.limit}张`);
      return false;
    },
    _avatarSuccessCheck(res) {
      const image = new Image();
      image.src = `${this.origin}/${res.data.files[0]}`;
      return new Promise((resolve) => {
        image.onload = () => {
          const { width } = image;
          const { height } = image;
          if (width != height) {
            this.$message.warning("必须上传正方形");
            resolve(false);
          } else if (
            width > 800 ||
            width < 130 ||
            height > 800 ||
            height < 130
          ) {
            this.$message.warning("长宽必须在130px~800px之间");
            resolve(false);
          } else {
            resolve(true);
          }
        };
      });
    },
    handleOpen(url) {
      window.open(apiBaseURL + url);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/supply/updateSupplyComponents/UploadCommonTemplate.vue